<template>
  <v-tabs v-model="tab" color="primary">
    <v-tab value="comments">Коментарі ({{ commentCount }})</v-tab>
    <v-tab value="files">Файли</v-tab>
    <v-tab value="links">Зв'язки ({{ relatedCount }})</v-tab>
    <v-tab value="history">Історія</v-tab>
  </v-tabs>
  <v-divider />
  <v-card-text class="px-0">
    <v-window v-model="tab">
      <v-window-item value="comments">
        <Comments
          :disabled="task.statusId === 3"
          :attach-name-folder="task.id"
          attach-main-folder="Задачи" />
      </v-window-item>
      <v-window-item value="files">
        <Files
          :task-id="task.id"
          :task-created-at="task.created_at"
          :disabled="disabled || task.statusId === 3" />
      </v-window-item>
      <v-window-item value="links">
        <Links />
      </v-window-item>
      <v-window-item value="history">
        <History :entity-id="task.id" />
      </v-window-item>
    </v-window>
  </v-card-text>
</template>

<script lang="ts">
import { computed, ref } from 'vue'
import Comments from '@/components/comments/v2/Comments.vue'
import Files from '@/pages/task/single/tabs/files/Files.vue'
import Links from '@/pages/task/single/tabs/links/Links.vue'
import History from '@/pages/task/single/tabs/history/History.vue'
import { useComments } from '@/components/comments/v2'

export default {
  name: 'TaskDetails',
  emits: ['update:model-value'],
  components: { Comments, Files, Links, History },
  props: {
    modelValue: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const tab = ref('comments')
    const { commentList } = useComments()

    const task = computed({
      get() {
        return props.modelValue
      },
      set(v) {
        emit('update:model-value', v)
      },
    })

    const commentCount = computed(() => commentList.value.length)
    const relatedCount = computed(() => task.value.related_tasks?.length || 0)

    return {
      commentCount,
      relatedCount,
      task,
      tab,
    }
  },
}
</script>
